// MODULAROOM chat session helpers.
// Persist a non-sensitive UUID in localStorage so returning visitors keep chat history.
// This is a public conversation identifier, not a credential.

const KEY = 'modularoom_session_id';
const LEAD_KEY = 'modularoom_lead_submitted';

const _genId = () =>
  (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export function getSessionId() {
  try {
    let s = localStorage.getItem(KEY);
    if (!s) {
      s = _genId();
      localStorage.setItem(KEY, s);
    }
    return s;
  } catch (e) {
    console.warn('[chatSession] localStorage unavailable, using ephemeral id:', e);
    return _genId();
  }
}

export function resetSession() {
  const s = _genId();
  try {
    localStorage.setItem(KEY, s);
  } catch (e) {
    console.warn('[chatSession] Could not persist new session id:', e);
  }
  return s;
}

export const isLeadSubmitted = () => {
  try {
    return localStorage.getItem(LEAD_KEY) === '1';
  } catch (e) {
    console.warn('[chatSession] Could not read lead flag:', e);
    return false;
  }
};

export const markLeadSubmitted = () => {
  try {
    localStorage.setItem(LEAD_KEY, '1');
  } catch (e) {
    console.warn('[chatSession] Could not persist lead flag:', e);
  }
};
